import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
// import { useFormik } from "formik";
import { Translate, Localize, getLocale, setLocale } from "react-i18nify";

import { reloginViaSocket } from "./HelperFunctions/socketFuntions";

import { checkView } from "./HelperFunctions/viewFunctions";
import HorizontalLayout from "./Components/NumberOfBags/HorizontalLayout";
import VerticalLayout from "./Components/NumberOfBags/VerticalLayout";

import formatFirstNameLastInitial from "./HelperFunctions/formatFirstNameLastInitial";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { submissionSocketEventsHandler } from "./Components/CustomerPhoneNumber/Shared/socketEventHelper";

import { Dlog } from "./../../utils/Dlog";

import HttpContext from "../../contexts/HTTP/HttpContext";
import KioskContext from "../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import { WORKFLOW_MODES } from "../../constants";

import "./../../font.css";

let env = require("./../../env");

const ERRORS = {
  400: "An error occurred while processing your login",
  401: "Invalid credentials provided",
  404: "Invalid credentials provided"
};

function NumberOfBags({ authenticate }) {
  const theme = useTheme();
  const { simplepost } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [loginError, setLoginError] = useState("");

  const [numbags, setNumbags] = useState("1");
  //const { customer, setCustomer } = useContext(KioskContext);
  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    socketEvents,
    sendEvent,
    clearSocketEvents,
    getKioskConfiguration,
    getKioskTheme
  } = useContext(SocketIOContext);

  //params
  // const { customerName } = route.params;

  const navigate = useNavigate();

  const [orientation, setOrientation] = useState(
    window.screen.orientation.type
  );

  const [workflowmode, setWorkflowmode] = useState(
    getKioskConfiguration()?.workflowMode
  );

  //Logic for response from Socket.IO
  useEffect(() => {
    //Listener for Submission Result Event
    submissionSocketEventsHandler({
      socketEvents: socketEvents,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      customerID: customerID,
      charityName: charityName,
      charityID: charityID,
      numBags: numBags,
      numLabels: numLabels,
      sessionID: sessionID,
      setAllFunc: setAll,
      setLoadingFunc: setLoading,
      //setErrorCodeFunc: setErrorCode,
      setErrorCodeFunc: () => {}, //TODO: Link this to some message
      //setErrorMessageFunc: setErrorMessage,
      successFunc: () => {
        return navigate("/printlabels");
      },
      errorFunc: () => {
        return navigate("/errorscreen");
      },
      clearSocketEventsFunc: clearSocketEvents
    });

    console.log("clearSocketEvents", clearSocketEvents);
    clearSocketEvents();
  }, [socketEvents, numBags]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientation(window.screen.orientation.type);
    };

    window.screen.orientation.addEventListener(
      "change",
      handleOrientationChange
    );

    return () => {
      window.screen.orientation.removeEventListener(
        "change",
        handleOrientationChange
      );
    };
  }, []);

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };
  // const { navigation } = this.props;

  // const formik = useFormik({
  //   initialValues: {
  //     email: "",
  //     password: ""
  //   },
  //   onSubmit: async values => {
  //     setLoading(true);
  //     setShowPassword(false);

  //     navigate("/");

  //     setLoading(false);
  //   }
  // });

  const next = () => {
    Dlog("next called");

    Dlog(
      "DEBUG context Dump 3",
      customerFirstName,
      customerLastName,
      customerID,
      numBags,
      numLabels
    );

    //setNumBags(numbags);
    setAll(
      //customerName, //customerName
      customerFirstName, //customerFirstName
      customerLastName, //customerLastName
      customerID, //customerID
      charityName, //charityName
      charityID, //charityID
      numbags, //numBags
      null, //numLabels
      null, //labelsList
      sessionID //sessionID
    );

    Dlog(
      "DEBUG context Dump 3-2",
      customerFirstName,
      customerLastName,
      customerID,
      numBags,
      numLabels
    );

    navigate("/numlabels");
  };

  // const handleKeyDown = event => {
  //   if (event.key === "Enter") {
  //     formik.handleSubmit();
  //   }
  // };

  const submitHelper = async (
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    newNumBags,
    sessionID,
    navigateErrorFunc,
    navigatePrintFunc
  ) => {
    if (!loading) {
      // console.log("DEBUG: [submitHelper] starting submitHelper");

      //Submit with the assumption that bags == labels
      let subscriptionID = localStorage.getItem("subscriptionID");
      let kioskID = localStorage.getItem("kioskID");

      setLoading(true);
      //KIOSKSUBMISSION
      const payload = {
        type: "KIOSKSUBMISSION",
        payload: {
          subscriptionID: subscriptionID,
          kioskID: kioskID,
          customerName: customerFirstName + " " + customerLastName,
          customerID: customerID,
          numBags: newNumBags,
          numLabels: newNumBags,
          sessionID: sessionID
          //overrideCode: overrideCode
        }
      };

      console.log("NumberOfBags payload", payload);

      sendEvent(payload, () => {
        console.log("onEventSent");
      });
    }
  };

  const numbagpress = async event => {
    const newNumBags = event.target.innerText;
    const kioskConfiguration = getKioskConfiguration();
    setNumbags(newNumBags);

    // console.log("DEBUG: starting workflowmode check");

    //Check workflowmode
    switch (workflowmode) {
      case WORKFLOW_MODES.BAG_ONLY_WITH_AUTH:
        setAll(
          customerFirstName, //customerFirstName
          customerLastName, //customerLastName
          customerID, //customerID
          charityName, //charityName
          charityID, //charityID
          newNumBags, //numBags
          newNumBags, //numLabels
          null, //labelsList
          sessionID //sessionID
        );

        const authenticationThreshold = parseInt(
          kioskConfiguration.authenticationThreshold ?? 1
        );

        // console.log(
        //   "DEBUG: [numberOfBags] kioskConfiguration",
        //   kioskConfiguration
        // );
        // console.log(
        //   "DEBUG: [numberOfBags] authenticationThreshold",
        //   authenticationThreshold
        // );

        // console.log("DEBUG: [numberOfBags] newNumBags", newNumBags);

        //navigate("/submissionApproval");

        if (
          authenticationThreshold &&
          parseInt(newNumBags) > authenticationThreshold
        ) {
          navigate("/submissionApproval"); //Navigate to Admin password page
        } else {
          await submitHelper(
            customerFirstName,
            customerLastName,
            customerID,
            charityName,
            charityID,
            newNumBags,
            sessionID,
            () => {
              navigate("/errorscreen");
            },
            () => {
              navigate("/printlabels");
            }
          );
        }
        break;

      case WORKFLOW_MODES.BAG_ONLY:
        await submitHelper(
          customerFirstName,
          customerLastName,
          customerID,
          charityName,
          charityID,
          newNumBags,
          sessionID,
          () => {
            navigate("/errorscreen");
          },
          () => {
            navigate("/printlabels");
          }
        );
        break;

      default:
        setAll(
          //customerName, //customerName
          customerFirstName, //customerFirstName
          customerLastName, //customerLastName
          customerID, //customerID
          charityName, //charityName
          charityID, //charityID
          newNumBags, //numBags
          null, //numLabels
          null, //labelsList
          sessionID //sessionID
        );

        navigate("/numlabels");
        break;
    }
  };

  //Return primary or secondary, depending if text matchs numbags
  const ispressed = buttonnumbag => {
    if (buttonnumbag === numbags) {
      return "secondary";
    }

    return "primary";
  };

  Dlog("locale", getLocale());

  const isNotMobile = useMediaQuery("(min-width:600px)");
  const isLandscape = useMediaQuery("(orientation:landscape)");

  // if (
  //   orientation == "landscape-primary" ||
  //   orientation == "landscape-secondary"
  // ) {
  if (checkView(orientation, getKioskTheme()) == "horizontal") {
    return (
      <HorizontalLayout
        numbagpress={numbagpress}
        workflowmode={workflowmode}
        getKioskConfiguration={getKioskConfiguration}
      />
    );
  } else {
    return (
      <VerticalLayout
        numbagpress={numbagpress}
        workflowmode={workflowmode}
        getKioskConfiguration={getKioskConfiguration}
      />
    );
  }
}

export default NumberOfBags;
